import { NgModule, InjectionToken, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule, ActionReducerMap } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { ShareModule } from '@app/components/share/share.module';

import { ShareFeedbackAppComponentsModule } from './components/components.module';
import { ShareFeedbackAppRouterModule } from './share-feedback.router';

import { projectRelatedVersionsReducer } from '@core/store/state/project-related-versions/project-related-versions.reducer';
import { ProjectRelatedVersionsEffects } from '@core/store/state/project-related-versions/project-related-versions.effects';


@NgModule({
    imports: [
        CommonModule,
        ShareModule,
        ShareFeedbackAppComponentsModule,
        ShareFeedbackAppRouterModule,
        StoreModule.forFeature('project_related_versions', projectRelatedVersionsReducer),
        EffectsModule.forFeature([ProjectRelatedVersionsEffects])
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
    ],
    exports: [
        ShareFeedbackAppComponentsModule,
        ShareFeedbackAppRouterModule
    ],

})
export class ShareFeedbackAppModule { }
